import { TFunction } from 'i18next';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export type RoleOption = {
  id: string;
  value: string;
  name: string;
  description: string;
};

export const getRequiredRoles = (t: TFunction): RoleOption[] => [
  {
    id: 'admin',
    value: 'admin',
    name: t('roles.admin'),
    description: 'Administrator role with full access',
  },
  {
    id: 'researcher',
    value: 'researcher',
    name: t('roles.researcher'),
    description: 'Researcher role with limited access',
  },
];

export const useRoles = () => {
  const { t } = useTranslation();
  const roles = useMemo(() => getRequiredRoles(t), [t]);
  return roles;
};
